import { Components, Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const MuiCheckbox = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: ({ theme, ownerState }) => {
      const color = ownerState.color!;
      return {
        color: theme.palette.neutral.onSurfaceVariant,
        '&:hover': {
          backgroundColor: alpha(theme.palette.neutral.onSurfaceVariant, theme.palette.action.hoverOpacity)
        },
        '&:active': {
          backgroundColor: alpha(theme.palette.neutral.onSurfaceVariant, theme.palette.action.activatedOpacity)
        },
        '&.Mui-focusVisible': {
          backgroundColor: alpha(theme.palette.neutral.onSurfaceVariant, theme.palette.action.focusOpacity)
        },
        '&.Mui-checked': {
          '&:hover': {
            backgroundColor: alpha(theme.palette[color].main, theme.palette.action.hoverOpacity)
          },
          '&:active': {
            backgroundColor: alpha(theme.palette[color].main, theme.palette.action.activatedOpacity)
          },
          '&.Mui-focusVisible': {
            backgroundColor: alpha(theme.palette[color].main, theme.palette.action.focusOpacity)
          },
        },
        '&.Mui-disabled': {
          color: theme.palette.action.disabled
        }
      };
    },
  },
} as Components<Theme>['MuiCheckbox'];
